import { useEffect } from 'react';

import { Box } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';

import Loader from '@/components/Loader';
import { useAppDispatch } from '@/hooks/redux-hooks';
import {
  clearPathnameFromStorage,
  useGxTokenFromStorage,
  usePathnameFromStorage,
  setGxTokenToStorage
} from '@/services/storage';
import { loginTrip } from '@/slices/authSlice';

const Home = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [urlSearchParams] = useSearchParams();
  const urlToken = urlSearchParams.get('token');
  const gxToken = useGxTokenFromStorage();
  const pathname = usePathnameFromStorage();

  const handleSetup = () => {
    if (gxToken) {
      if (pathname && pathname !== '/login') {
        clearPathnameFromStorage();
        navigate(pathname);
      } else {
        navigate('/markets');
      }
    } else handleLoginTrip();
  };

  const handleLoginTrip = async () => {
    if (urlToken) {
      const data = await dispatch(loginTrip(urlToken));
      if (data?.meta.requestStatus !== 'rejected') {
        setGxTokenToStorage(urlToken);
        if (pathname && pathname !== '/login') {
          clearPathnameFromStorage();
          navigate(pathname);
        } else {
          navigate('/markets');
        }
      }
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    handleSetup();
  }, [urlToken]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <Loader />
    </Box>
  );
};

export default Home;
